import Helper from 'app/modules/Helper';
import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkCookieSearchData, init } from '../../../actions/baseActions';
import Flights from '../../../app/components/Flights/Flights';

export type LocationTexts = {
	metaTitle: string;
	metaDescription: string;
	h1: string;
	h2: string;
	newsletter: string;
};

const FlightsCityLocationPage: NextPage = (props: any) => {
	const { t } = useTranslation();
	const location = props.location;

	const locationName = location
		.split(' ')
		.map((item: string) => Helper.capitalize(item))
		.join(' ');
	const metaTitle = t('mainArea.flights.city.location.metaTitle', { location: locationName });
	const metaDescription = t('mainArea.flights.city.location.metaDescription', { location: locationName });
	const h1 = t('mainArea.flights.city.location.h1', { location: locationName });
	const h2 = t('mainArea.flights.city.location.h2', { location: locationName });
	const newsletter = t('mainArea.flights.city.location.newsletter', { location: locationName });
	const texts: LocationTexts = {
		metaTitle,
		metaDescription,
		h1,
		h2,
		newsletter,
	};

	const dispatch = useDispatch();
	useEffect(() => {
		init('flights')(dispatch);
		checkCookieSearchData()(dispatch);
	}, []);

	return (
		<div>
			<NextSeo
				title={texts.metaTitle}
				description={texts.metaDescription}
				canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/flights/city/${location}`}
				openGraph={{
					url: `${process.env.NEXT_PUBLIC_SITE_URL}/flights/city/${location}`,
					title: texts.metaTitle,
					description: texts.metaDescription,
					site_name: process.env.NEXT_PUBLIC_SITE_NAME,
				}}
			/>
			<Flights
				dynamic
				useHeadline
				page={{
					slug: `city/${location}`,
				}}
				query={{ ...props.query, texts }}
			/>
		</div>
	);
};

export async function getServerSideProps(ctx: any) {
	const location = ctx.query.location;
	const query = ctx.query;
	return {
		props: { location, query }, // will be passed to the page component as props
	};
}

export default FlightsCityLocationPage;
